// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class HcpIntakeResponseModel {
    'accountId': number;
    'accountDisplayId': string;
    'intakeCaseId': number;
    'workflowIds': Array<number>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof HcpIntakeResponseModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "accountDisplayId",
            "baseName": "accountDisplayId",
            "type":     "string"
        },
        {
            "name":     "intakeCaseId",
            "baseName": "intakeCaseId",
            "type":     "number"
        },
        {
            "name":     "workflowIds",
            "baseName": "workflowIds",
            "type":     "Array<number>"
        },
    ];

    static getAttributeTypeMap() {
        return HcpIntakeResponseModel.attributeTypeMap;
    }
}
